export default __webpack_public_path__ + "static/media/trivia-i.431fdefb.png";